<div class="container-fluid wrapper-page">


  <div class="page-head">
    <h5 class="header-title heading-color">Search Coupon</h5>
  </div>
  <div class="card">
    <ng-container>
      <section class="mt-3 m-b-15 align-items-center">

        <form [formGroup]="couponSearchForm">
          <div class="card-body">

            <!--SEARCH COUPON BY ID-->
            <div class="row">
              <div class="col-12">
                <h6 class="text-center">ENTER COUPON ID</h6>
              </div>
            </div><br>

            <div class="row">
              <div class="col-lg-4 col-md-3"></div>

              <div class="col-lg-2 col-md-3 col-sm-12 col-xs-12 ml-3">
                <input type="text" formControlName="coupon_id" class="form-control select" placeholder="Coupon Id" />
              </div>

              <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <button type="submit" name="find" class="btn btn-primary text-white btn-rounded mt-2"
                  (click)="findCoupon()">FIND COUPON</button>
              </div>

              <div class="col-lg-3 col-md-3"></div>
            </div>

          </div>
        </form>
      </section>
    </ng-container>
  </div>

  <br>
  <!--COUPON TABLE-->
  <div class="container-fluid" *ngIf="allCouponDetails?.length">
    <div class="row">
      <div class="col-lg-12">
        <div class="card m-b-30">
          <div class="card-body table-responsive">
            <div class="col-md-12 detail-tbl">
              <table class="table">
                <thead>
                  <tr>
                    <th scope=" col" class="th-item ">COUPON ID</th>
                    <th scope="col" class="th-item ">DISCOUNT %</th>
                    <th scope="col" class="th-item ">VALID FROM</th>
                    <th scope="col" class="th-item ">VALID TO</th>
                    <th scope="col" class="th-item ">DESCRIPTION</th>
                    <th scope="col" class="th-item text-center">ASSIGNED TO</th>
                    <th scope="col" class="th-item ">ACTIVATE</th>
                    <th scope="col" class="th-item "></th>
                  </tr>
                </thead>
                <tr *ngFor="let coup of allCouponDetails; let i = index">

                  <td class="font-size-15 text-color align-middle">{{coup?.id}}</td>
                  <td class="font-size-15 text-color align-middle">{{coup?.discount_percent}}</td>
                  <td class="font-size-15 text-color align-middle">{{coup?.valid_from| date: "dd-MMM-yyyy"}}</td>
                  <td class="font-size-15 text-color align-middle">{{coup?.valid_to| date: "dd-MMM-yyyy"}}</td>
                  <td class="font-size-15 text-color align-middle text-wrap col-md-2">{{coup?.description}}</td>
                  <td class="font-size-15 text-color align-middle text-center">{{coup.scope ===
                    'ALL'?'ALL':(coup.email_id?coup.email_id:'-')}}</td>


                  <td class="align-middle">
                    <span class="custom-control  custom-switch d-inline-block">
                      <input type="checkbox" class="custom-control-input cursor" [checked]="coup?.active"
                        (change)="onCouponStatusChange(i, coup?.active)" [id]="i" [disabled]="expiryCheck(i)" />
                      <label class="custom-control-label cursor" [for]="i"></label>
                    </span>
                  </td>
                  <td class="align-middle">
                    <div class="d-flex">
                      <button type="button" class="btn btn-primary btn-model"
                        routerLink="/superadmin/coupon-edit/{{coup.id}}" [disabled]="expiryCheck(i)">Edit</button>
                    </div>
                  </td>

                </tr>
                <tbody>
                  <tr>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>


  </div>
</div>